//App

//SIGNIN
export const SIGNIN_REQUEST = '@@signin/REQUEST'
export const SIGNIN_SUCCESS = '@@signin/SUCCESS'
export const SIGNIN_FAILURE = '@@signin/FAILURE'

//PROFILE
export const PROFILE_ADD = '@@profile/ADD'
export const PROFILE_SUCCESS = '@@profile/SUCCESS'
export const PROFILE_FAILURE = '@@profile/FAILURE'

//JOBSEARCH
export const JOBSEARCH_ADD = '@@jobSearch/ADD'
export const JOBSEARCH_SUCCESS = '@@jobSearch/SUCCESS'
export const JOBSEARCH_FAILURE = '@@jobSearch/FAILURE'
export const JOBSEARCH_DELETE = '@@jobSearch/DELETE'

//TEST
export const TEST_REQUEST = '@@test/REQUEST'
export const TEST_ANSWER = '@@test/ANSWER'
export const TEST_SUCCESS = '@@test/SUCCESS'
export const TEST_FAILURE = '@@test/FAILURE'
export const TEST_START = '@@test/START'

//LOADING
export const LOADING_START = '@@loading/START'
export const LOADING_STOP = '@@loading/STOP'

//TEST


export function makeActionCreator(type, ...argNames) {
    return function (...args) {
        let action = { type: type }
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index]
        })
        return action
    }
}



// WEBPACK FOOTER //
// ./src/actionTypes.js